import React, { useRef, useEffect, useState } from "react";
import "../../Components/text.css";
import "../../Home/Home.css";
import "../../Home/Components/Expertise.css";
import Peopletab from "./Peopletab";
import claraImage from "../../Assets/Images/Peopleimages/Adnan-Yaqub.jpeg";
import owenImage from "../../Assets/Images/Peopleimages/Dr.-Naveed-ALamCEO.jpg";
import isabellaImage from "../../Assets/Images/Peopleimages/Toby-McNeill.jpeg";
import hansImage from "../../Assets/Images/Peopleimages/Hans-watersprint-1.jpg";
import arshadImage from "../../Assets/Images/Peopleimages/Arshad_mian.jpg";
import sheraz from "../../Assets/Images/Peopleimages/sheraz.jpg"

export default function People() {
  const expertiesedat = [
    {
      name: "Adnan Yaqub Chaudhry",
      title: "Company Secretary & Director",
      image: claraImage,
    },
    {
      name: "Dr. Naveed Alam",
      title: "Climate & Water Expert",
      image: owenImage,
    },
    {
      name: "Toby McNeill",
      title: "Finance Expert",
      image: isabellaImage,
    },
    {
      name: "Dr. Hans Beekman",
      title: ["Key Expert and Advisor —", "Water Management and Hydrogeologist"],
      image: hansImage,
    },
    {
      name: "Sheraz Hussain",
      title: ["Technology expert"],
      image: sheraz,
    },
    {
      name: "Muhammad Arshad Mian",
      title: "Project Management Expert",
      image: arshadImage,
    },
  ];

  const scrollContainerRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const intervalRef = useRef(null);

  // Auto scroll function
  const autoScroll = () => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const maxScroll = container.scrollWidth - container.clientWidth;
    const currentScroll = container.scrollLeft;

    // If near end, jump to start
    if (currentScroll >= maxScroll - 10) {
      container.scrollTo({ left: 0, behavior: "smooth" });
    } else {
      container.scrollBy({ left: 300, behavior: "smooth" }); // Move by one card + gap
    }
  };

  // Start auto-scroll
  useEffect(() => {
    if (isHovered) return;

    intervalRef.current = setInterval(() => {
      autoScroll();
    }, 3000); // Change slide every 3 seconds

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isHovered]);

  // Pause on hover
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return (
    <div
      style={{
        width: "75vw",
        maxWidth: "890px",
        textAlign: "center",
        margin: "0 auto",
        padding: "2rem 0",
        position: "relative",
      }}
    >
      {/* Main Heading */}
      <h2
        style={{
          fontSize: 36,
          fontFamily: "Arial",
          fontWeight: "bold",
          color: "#0D1C17",
          marginBottom: "1.5rem",
          textAlign: "left",
        }}
      >
        Our Experts
      </h2>

      {/* Scrollable Container */}
      <div
        ref={scrollContainerRef}
        className="scrollbar-custom"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          display: "flex",
          flexDirection: "row",
          overflowX: "auto",
          whiteSpace: "nowrap",
          padding: "10px 0",
          gap: "1.5rem",
          scrollBehavior: "smooth",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {expertiesedat.map((item, index) => (
          <div
            key={index}
            style={{
              flex: "0 0 auto",
              width: "280px",
            }}
          >
            <Peopletab image={item.image} Name={item.name} Title={item.title} />
          </div>
        ))}
      </div>

      {/* Hide scrollbar */}
      <style>
        {`
          .scrollbar-custom::-webkit-scrollbar {
            display: none;
          }
        `}
      </style>
    </div>
  );
}